import { render, staticRenderFns } from "./TenderPositionCard.vue?vue&type=template&id=dc4a33be&scoped=true&"
import script from "./TenderPositionCard.vue?vue&type=script&lang=js&"
export * from "./TenderPositionCard.vue?vue&type=script&lang=js&"
import style0 from "./TenderPositionCard.vue?vue&type=style&index=0&id=dc4a33be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4a33be",
  null
  
)

export default component.exports